import React from "react";
import { Link } from "react-router-dom";

export function NewHero(props) {
  return (
    <section className="safetyAppHeroContainerNew">
      <div className="safetyAppHeroContent">
        <div className="safetyAppHeroTextContainer">
          <h1 className="largeHeadline white mb-4">
            Safety Starts With{" "}
            <span className="yellowTextHighlight">Smarter Software</span>
          </h1>
          <p className="bodyText white  mb-4" style={{ color: "white" }}>
            Our platform uses intelligent data analysis to proactively identify
            and mitigate risks, creating a safer work environment that reduces
            injuries, lowers costs, and protects your most valuable assets—your
            employees.
          </p>
          <Link to="/get-a-demo">
            <button className="roundBtn">
              Get Started <span className="btnEmphasis"> Today</span>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}
